import type { IReportRejectSelectionSnapshot } from "./Report";

export interface IUserSettingsRequest {
    username: string;
    grainId?: string;
    profileId?: string;
    orgId?: string;
    settingName?: string;
}

export interface IUpdateUserSettingsRequest {
    username: string;
    grainId?: string;
    profileId?: string;
    settingName?: string;
    newSetting?: any;
    [key: string]: any;
}

export interface IUserUpdateLogoRequest {
    username: string;
    logo: string;
}
export interface IUserSettingsResponse {
    settings: string;
}

export interface IAllUserSettingsResponse {
    logo: string;
    scanner_id: ScannerId;
    info_fields: InfoField[];
    scan_dpi: number;
    lightbox_enabled: boolean;
    lightbox_background_color?: string;
    lightbox_sheet_width_cm?: number;
    lightbox_sheet_length_cm?: number;
    result_edit_enabled: boolean;
    whiteness_index_enabled: boolean;
    good_and_reject_percent_enabled: boolean;
    rice_profile_selection_enabled: boolean;
    manual_entry_enabled: boolean;
    preferredProcessingMode?: 'local' | 'cloud';
    show_job_history?: boolean;
    delete_ml_dataset_allowed?: boolean;
    create_ml_training_job_allowed?: boolean;
    create_ml_testing_job_allowed?: boolean;
}

export enum ScannerId {
    DOUBLE_SIDED = "DOUBLE_SIDED",
    DS1 = "DS1", // Legacy double-sided scanner ID
    EPSON = "EPSON",
    EPSON_V39 = "EPSON_V39",
    MICROTEK_XT3500 = "MICROTEK_XT3500",
}

// Helper function to check if scanner is double-sided
export const isDoubleSidedScanner = (scannerId: string | ScannerId | undefined): boolean => {
    return scannerId === ScannerId.DOUBLE_SIDED || scannerId === ScannerId.DS1 || scannerId === 'DS1' || scannerId === 'DOUBLE_SIDED';
};

export interface InfoField {
    fieldName: string;
    displayName: string;
    type: string;
    unit: string;
    category: string;
}

export interface IUserSettings {
    settings?: any;
    source?: 'user' | 'org' | 'global' | 'none' | string;
    lightbox_background_color?: string;
    lightbox_sheet_width_cm?: number;
    lightbox_sheet_length_cm?: number;
    particle_distribution_1: { key: string, value: any }[];
    particle_distribution_2: { key: string, value: any }[];
    particle_distribution_3: { key: string, value: any }[];
    particle_distribution_reject_config?: IReportRejectSelectionSnapshot;
    rejected_grains_reject_config?: IReportRejectSelectionSnapshot;
    grain_and_profiles: { key: string, value: any }[];
    preferredProcessingMode?: 'local' | 'cloud';
}
